import { render } from "./BaseAccordion.vue?vue&type=template&id=79d67324&scoped=true"
import script from "./BaseAccordion.vue?vue&type=script&lang=js"
export * from "./BaseAccordion.vue?vue&type=script&lang=js"

import "./BaseAccordion.vue?vue&type=style&index=0&id=79d67324&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d67324"]])

export default __exports__